
import { getNoticeList, deleteNotice, publishNotice } from "@/api/api-basic";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import postNoticeAdd from "./components/post-notice-add.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-post-notice-add": postNoticeAdd
  }
})
export default class OperatorPostNotice extends Vue {
  private formInline: objAny = {
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: "",
    beginDate: "",
    endDate: ""
  };
  private ruleInline = {};
  private privilege = {};
  private time: string[] = [];
  private selectList: object[] = [];
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("postNotice.title"),
      key: "title",
      minWidth: 140
    },
    {
      title: i18n.t("postNotice.content"),
      key: "content",
      minWidth: 360,
      tooltip: true
    },
    {
      title: i18n.t("postNotice.createTime"),
      key: "createTime",
      minWidth: 160
    },
    {
      title: i18n.t("postNotice.publishTime"),
      key: "publishTime",
      minWidth: 160
    },
    {
      title: i18n.t("postNotice.publishStatus"),
      key: "publishStatusDesc",
      minWidth: 100
    },
    {
      title: i18n.t("operation"),
      width: 200,
      slot: "action"
    }
  ];
  private loading = false;
  private total = 0;

  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getNoticeList(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  async delClick(item: objAny): Promise<void> {
    const ret = await deleteNotice({ noticePkId: item.noticePkId });

    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
    }
  }
  async publishBtn(item: objAny): Promise<void> {
    const publishStatus: number = item.publishStatus == 1 ? 0 : 1;
    const ret = await publishNotice({
      noticePkId: item.noticePkId,
      publishStatus: publishStatus
    });

    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.getTableList();
    }
  }
  public selectItem(list: object[]) {
    this.selectList = list;
  }

  public detailBtn(item: objAny) {
    const postNoticeAdd: objAny = this.$refs.postNoticeAdd;
    postNoticeAdd.open("details", item);
  }
  public addBtn() {
    const postNoticeAdd: objAny = this.$refs.postNoticeAdd;
    postNoticeAdd.open("add");
  }

  private timeFn(val: objAny): void {
    if (val[0] !== "" && val[1] !== "") {
      this.formInline.beginDate = val[0];
      this.formInline.endDate = val[1];
    } else {
      this.formInline.beginDate = "";
      this.formInline.endDate = "";
    }
  }

  mounted() {
    this.privilege = this.$route.meta.privilegeVoObj;

    // const time: string = this.$common.thisTimes("yyyy-MM-dd");
    // const timeArr: string[] = time.split("-");
    // this.formInline.beginDate = timeArr[0] + "-" + timeArr[1] + "-01";
    // this.formInline.endDate = time;
    // this.time = [this.formInline.beginDate, this.formInline.endDate];
    this.getTableList();
  }
}
